export default class FeedbackFormController {
    /** @ngInject */
    constructor(FeedbackApi, ToastService, AuthService) {
        this.FeedbackApi = FeedbackApi;
        this.ToastService = ToastService;
        this.AuthService = AuthService;
    }

    $onInit() {
        this.isScreenshot = true;
        this.getAuthData();
        this.isRendered = true;
    }

    getAuthData() {
        const authData = this.AuthService.getAuthData();

        if (authData) {
            this.userProfile = authData.profile;
        }
    }

    /**
     * Convert image to base64
     * @param el - image element in DOM
     */
    toBase64() { // eslint-disable-line class-methods-use-this
        const canvas = document.querySelector('.dtHelp-screenshot__preview canvas');
        if (!canvas) return '';

        return canvas.toDataURL('image/png').replace(/^data:image\/(png|jpg);base64,/, '');
    }

    send() {
        this.inProgress = true;

        const image = this.toBase64();
        const feedback = {
            name: this.userProfile.name,
            email: this.feedbackFormData.email,
            subject: this.feedbackFormData.subject,
            body: this.feedbackFormData.body,
            image_base64: image
        };

        this.FeedbackApi
            .create(feedback)
            .then(() => {
                this.ToastService.showSimpleTranslated('ticket_was_submitted');
            })
            .catch(() => {
                this.ToastService.showSimpleTranslated('ticket_wasnt_submitted');
            })
            .finally(() => {
                this.inProgress = false;
                this.onCancel();
            });
    }
}



// WEBPACK FOOTER //
// ./app/common/help-menu/feedback-form/feedback-form.controller.js